import * as types from '../types/language';
import { DEFAULT_LANGUAGE } from '../constants';


export default function Language(state = {
  defaultLanguage: DEFAULT_LANGUAGE,
}, action) {
  switch (action.type) {
    case types.SET_LANGUAGE:
      return {
        ...state,
        defaultLanguage: action.data
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/language.js